import money from './money'
// import address from 'address'

export default {
  install(Vue) {
    Vue.component(money.name, money)
    Vue.component(money.alias, money)
    // Vue.component(address.name, address)
  }
}



// WEBPACK FOOTER //
// ./src/core/value-objects/index.js